import actions, { IState } from '../actions';

import { ISearchQuery } from '../interfaces';
import React from 'react';
import ReactHookz from '../../ReactHookz';

const initialSearchQuery: ISearchQuery = {
  query: '',
  pagination: {
    pageNumber: 1,
    pageSize: 24,
    pageGap: 0,
    previousTotalGap: 5,
  },
  sort: {
    ascending: true,
    sortName: 'brand',
  },
  viewFilter: {
    view: '',
    view_size: 1,
    viewName: '',
  },
  selectFilters: {
    filters: [],
    selectedExclusiveTopFilter: '',
    selectedNonExclusiveTopFilter: [],
    selectedTextQueries: [],
    favoritesTopFilterEnabled: false
  },
};

const initialState: IState = {
  token: undefined,
  hasToken: false,
  favorites: undefined,
  configuration: {
    brand: 'Optimizely',
    url: 'https://www.optimizely.com',
    country: 'US',
    facets: [],
    smartSystemSelectorContent: [
      {
        smartListerLabels: {
          numberOfResults: 'Number of results', // TODO
          loadMore: 'Load more', // TODO
          searchTitle: 'Search', // TODO
          searchPlaceholder: 'Search...', // TODO
          searchInfo: 'Search for products, categories, or brands', // TODO
          searchButtonLabel: 'Search', // TODO
          clearButtonTooltip: 'Clear search', // TODO
          filters: 'Filters', // TODO
          hideFilters: 'Hide filters', // TODO
          showMore: 'Show more',
          showLess: 'Show less',
          resetFilters: 'Reset filters', // TODO
          showResults: 'Show results', // TODO
          clearAll: 'Clear all', // TODO
          selectAll: 'Select all', // TODO
          previous: 'Previous', // TODO
          currentPage: 'Current page', // TODO
          paginationItems: 'Items per page', // TODO
          quickView: 'Quick view', // TODO
          addToSpec: 'Add to spec pack', // TODO
          copyHover: 'Copy to clipboard',
          saveSystemFavoritesHover: 'Save to favorites',
          unSaveSystemFavoritesHover: 'Remove from favorites',
          copyToClipboardToastMessage: 'Copied to clipboard successfully!',
          closeButtonHoverText: 'Close quick view', // TODO
          technicalPropertiesTitle: 'Technical properties',
          viewProductDetail: 'View product detail',
        },
        systemSelectorLabels: {
          toLabel: 'to', // TODO
          rangeDescriptionFormatLabel: '{0} - {1}', // TODO
          allCategoriesLabel: 'All categories', // TODO
          categoriesLabelMobile: 'Categories', // TODO
          mainCategoryLabelPrefix: 'Main category:', // TODO
          advancedFiltersLabel: 'Advanced filters', // TODO
          advancedFiltersApplyLabel: 'Apply', // TODO
          advancedFiltersMinimumLabel: 'Minimum', // TODO
          advancedFiltersMaximumLabel: 'Maximum', // TODO
          advancedFiltersSelectPlaceholder: 'Select an option', // TODO
          clearSearchResults: 'Clear search results', // TODO
          itemsPerPage: 'Page|of',
          numberOfResultsForSearchText: '{0} results found for "{1}"', // TODO
          noResultTile: 'No results found', // TODO
          noResultSubTile: 'Try adjusting your search or filter criteria.', // TODO
          sortByPopular: 'Sort by popularity', // TODO
          sortByCreatedDate: 'Sort by created date', // TODO
          name: 'Name', // TODO
          shortDescription: 'Short description', // TODO
          emptyValueReplacer: '-', // TODO
          numberOfEntitiesSelected: '{0} entities selected for comparison.', // TODO
          compareButtonLabel: 'Compare selected systems', // TODO
          compareButtonTooltip: 'Click to compare the selected systems.', // TODO
          cancelButtonLabel: 'Cancel', // TODO
          stickyToastMessage: '{0} systems added to comparison successfully.', // TODO
        },
        aiSearchLabels: {
          searchWindowTitle: 'AI Search',
          conversationWindowPlaceholder:
            'Start a conversation with our AI assistant to find the perfect systems for your needs.',
          conversationExample1:
            'I need a system for high-traffic commercial areas',
          conversationExample2:
            'What options do you have for fire-resistant applications?',
          conversationExample3: 'Show me systems suitable for wet environments',
          conversationInputPlaceholder1: 'Ask me anything about our systems...',
          conversationInputPlaceholder2: 'Continue the conversation...',
          identifiedFiltersConversationPart:
            "Based on your request, I've identified these filters:",
          identifiedFiltersMessage:
            'Here are the filters that match your requirements', // TODO
          sendButton: 'Send',
          showResultsButton: 'Show Results',
          resetButton: 'Reset',
          conversationContinuationQuestion:
            'Would you like to refine your search further?', // TODO
        },
      },
    ] as any,
  },
  selectedPageSize: 24,
  counter: -1,
  selectedFacets: [],
  gridData: [],
  contentHubData: {
    list: [],
    count: 0,
    currentPage: 0,
    pageCount: 0,
    pageSize: 0,
    isLastPage: false,
    totalCount: 0,
  } as any,
  selectedSystems: [],
  selectFilters: {
    filters: [],
    selectedExclusiveTopFilter: '',
    selectedNonExclusiveTopFilter: [],
    selectedTextQueries: [],
    favoritesTopFilterEnabled: false
  },
  topFilterListExclusive: [],
  topFilterListNonExclusive: [],
  query: initialSearchQuery,
  results: {
    sortFilter: {
      sortName: '',
      ascending: true,
    },
    facets: [],
    selectFilters: {
      selectedExclusiveTopFilter: '',
      selectedNonExclusiveTopFilter: [],
      filters: [],
      selectedTextQueries: [],
      favoritesTopFilterEnabled: false
    },
    list: [],
    favoriteIds: [],
    isAuthenticated: false,
    count: 0,
    currentPage: 0,
    pageCount: 0,
    pageSize: 0,
    isLastPage: false,
    totalCount: 0,
    listerFields: [],
    gridFeaturedFields: [],
    gridPerformanceFields: [],
    quickViewFields: [],
    attributesForSortingDropdown: [],
    topFilterListExclusive: [],
    topFilterListNonExclusive: [],
  },
  isLoading: true,
  infoPanel: {
    isVisible: false,
    title: '',
    richtText: [],
  },
};

export const useReactHookz = ReactHookz(React, initialState, actions);
